var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "4167.000000pt",
    height: "4167.000000pt",
    viewBox: "0 0 4167.000000 4167.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,4167.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4580 20835 l0 -17085 16255 0 16255 0 0 10210 0 10210 -3750 0 -3750 0 0 6875 0 6875 -12505 0 -12505 0 0 -17085z m12925 9585 l0 -835 -4172 -3 -4173 -2 0 833 c0 459 3 837 7 840 3 4 1881 6 4172 5 l4166 -3 0 -835z m2915 -4585 l0 -835 -5630 0 -5630 0 0 835 0 835 5630 0 5630 0 0 -835z m15000 -11875 l0 -8540 -2915 0 -2915 0 0 8540 0 8540 2915 0 2915 0 0 -8540z m-12500 7295 l0 -835 -6880 0 -6880 0 0 835 0 835 6880 0 6880 0 0 -835z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutHover);
export default __webpack_public_path__ + "static/media/about-hover.a7eca920ad272f434292d3078151eb2f.svg";
export { ForwardRef as ReactComponent };